export default __webpack_public_path__ + "static/media/folder.df8b7044.svg";